import React from "react";
import ForgotPassword from "../auth/ForgotPassword";
import CommonAuthHeader from "./CommonAuthHeader";

const OptionsForgotPassword = () => {
  return <ForgotPassword isFromOptions />;
};

export default OptionsForgotPassword;
